import { render, staticRenderFns } from "./siteIndHygieneJournalItem.vue?vue&type=template&id=384c67fa"
import script from "./siteIndHygieneJournalItem.vue?vue&type=script&lang=js"
export * from "./siteIndHygieneJournalItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('384c67fa')) {
      api.createRecord('384c67fa', component.options)
    } else {
      api.reload('384c67fa', component.options)
    }
    module.hot.accept("./siteIndHygieneJournalItem.vue?vue&type=template&id=384c67fa", function () {
      api.rerender('384c67fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/siteIndHygieneJournalItem.vue"
export default component.exports